<template>
<!-- 企业信息 -->
  <div class="enterprise">
    <div class="enterprise-detail">
      <div class="title clearfix">
        <h2>{{formData.name}}</h2>
        <div class="a clearfix">
          <div>法定代表人：<span>{{formData.corpRep}}</span></div>
          <div>统一社会信用代码：<span>{{formData.uscCode}}</span></div>
        </div>
      </div>

      <div class="enterprise-list">
        <el-row>
          <el-col :span="8">成立日期：<span>{{formData.setUpDate}}</span></el-col>
          <el-col :span="8">是否上市(不含新三板)：<span>{{formData.ifListedDesc}}</span></el-col>
          <el-col :span="8">统称：<span>{{formData.generalName}}</span></el-col>
          <el-col :span="8"
            >简称：<span>{{formData.abbreviationName}}</span></el-col
          >
          <el-col :span="8">产品大类：<span>{{formData.productCategoryLabel}}</span></el-col>
          <el-col :span="8">认缴注册资本(万元)：<span>{{formData.assessedCapital}}</span></el-col>
          <el-col :span="8"
            >公司网址：<span>{{formData.companyWebsite}}</span></el-col
          >
          <el-col :span="8">境内货源地：<span>{{formData.customsAreaCode}}</span></el-col>
          <el-col :span="8">境内目的地：<span>{{formData.domesticDestination}}</span></el-col>
          <el-col :span="8">英文名称：<span>{{formData.englishName}}</span></el-col>
          <el-col :span="8"
            >英文地址：<span>{{formData.englishAddress}}</span></el-col
          >
          <el-col :span="8">市场领域：<span>{{formData.marketFieldDesc}}</span></el-col>
          <el-col :span="8">海关注册编码：<span>{{formData.customsRegistrationCode}}</span></el-col>
          <el-col :span="8">检验检疫编码：<span>{{formData.inspectionQuarantineCode}}</span></el-col>
          <el-col :span="8">目的地代码：<span>{{formData.destinationCode}}</span></el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <h5>公司股东及出资情况：</h5>
            <div v-if="formData.shareholdersAndInvestment">{{formData.shareholdersAndInvestment}}</div>
          </el-col>
          <el-col :span="24">
            <h5>合作模式及需求：</h5>
            <div v-if="formData.cooperationPattern">{{formData.cooperationPattern}}</div>
          </el-col>
          <el-col :span="24">
            <h5>公司简介：</h5>
            <div v-if="formData.companyProfile">{{formData.companyProfile}}</div>
          </el-col>
        </el-row>
      </div>

      <div class="contact">
        <h3>联系人</h3>
        <el-table
          :data="formData.principalLinkmanEntryList"
          stripe
          style="width: 100%"
          :header-cell-style="{ background: '#F2F7FF', color: '#000' }"
        >
          <el-table-column prop="role" label="商务角色" width="140" />
          <el-table-column prop="name" label="姓名" width="140" />
          <el-table-column prop="gender" label="性别" width="120" />
          <el-table-column prop="number" label="身份证号码" width="210" />
          <el-table-column prop="phone" label="手机" width="180" />
          <el-table-column prop="carNumber" label="车牌号" width="160" />
          <el-table-column prop="address" label="地址" width="210" />
          <el-table-column prop="remark" label="备注" width="200" />
        </el-table>
      </div>

      <div class="invoice">
        <h3>开票资料</h3>
        <div class="invoice-top">
          <el-row>
            <el-col :span="8"
              >开票名称：<span>{{formData.principalExtend.billName}}</span></el-col
            >
            <el-col :span="8"
              >纳税人识别号：<span>{{formData.principalExtend.taxpayerCode}}</span></el-col
            >
            <el-col :span="8">
                地址：<span>{{formData.principalExtend.billAddress}}</span>
            </el-col>
            <el-col :span="8">电话：<span>{{formData.principalExtend.billTel}}</span></el-col>
            <el-col :span="8">开户银行：<span>{{formData.principalExtend.billBankName}}</span></el-col>
            <el-col :span="8">账号：<span>{{formData.principalExtend.billBankAcct}}</span></el-col>

            <el-col :span="24">
              备注：
              <span>{{formData.principalExtend.billRemark}}</span>
            </el-col>
          </el-row>
        </div>

        <div class="invoice-bottom">
          <el-row>
            <el-col :span="24">
              <h5>客户的主要客群及区域分布：</h5>
              <div v-if="formData.principalExtend.mainCustomerGroup" class="divWord">{{formData.principalExtend.mainCustomerGroup}}</div>
            </el-col>
            <el-col :span="24">
              <h5>客户业务信息描述（包含历史进出口量，进出口主要商品，出货习惯）：</h5>
              <div v-if="formData.principalExtend.customerBusinessDesc" class="divWord">{{formData.principalExtend.customerBusinessDesc}}</div>
            </el-col>
            <el-col :span="24">
              <h5>客户曾经使用的服务商有哪些及业务类：</h5>
              <div v-if="formData.principalExtend.servicesUsed" class="divWord">{{formData.principalExtend.servicesUsed}}</div>
            </el-col>
            <el-col :span="24">
              <h5>客户特殊要求：</h5>
              <div v-if="formData.principalExtend.specialRequirement" class="divWord">{{formData.principalExtend.specialRequirement}}</div>
            </el-col>
          </el-row>

            <ab-upload :params="uploadParams"></ab-upload>
        </div>
      </div>

      <div class="return">
        <el-button @click="collback">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-enterprise',
  data() {
    return {
        userInfo: this.$utils.getSessionStorage('userInfo'),
        formData: {
            principalLinkmanEntryList: [],
            principalExtend: {}
        },
      // 附件管理
      uploadParams: {
        coreBillIds: '',
        coreBillNumbers: '',
        sourceBillId: '',
        sourceBillNumber: '',
        sourceBillType: 'Principal',
        billType: '',
        items: [
          {
            title: '营业执照',
            attachType: '010',
            required: true
          },
          {
            title: '开票资料',
            attachType: '020'
          },
          {
            title: '银行账号',
            attachType: '030'
          }
        ]
      }
    };
  },
  computed: {
    mainTabs: {
      get () {
        return this.$store.state.mainTabs
      },
      set (val) {
        this.$store.commit('updateMainTabs', val)
      }
    }
  },
  methods:{
    init () {
      this.$get('/bas/principal/get', { id: this.userInfo.outerOrgId })
        .then(({ data }) => {
          if (data.code === 'C0000') {
            this.formData = data.result
            this.uploadParams.sourceBillId=this.formData.id
            this.uploadParams.sourceBillNumber=this.formData.number
          }
        })
    },
    collback () {
        this.removeTabHandle('企业信息')
    },
    removeTabHandle (tabName) {
      this.mainTabs = this.mainTabs.filter(item => item.name !== tabName)
      if (this.mainTabs.length > 0) {
        this.$router.push({
            path: '/my-list'
        })
      } else {
        this.$router.push({ path: '/' })
      }
    },
  },
  mounted(){
    this.init()
  }
};
</script>

<style lang='scss'>
.enterprise {
  padding: 40px 0 20px;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  .word-14 {
    font-size: 14px;
  }
  .enterprise-detail {
    width: 1360px;
    margin: 0 auto;

    .title {
      margin-bottom: 29px;
      h2 {
        float: left;
        margin-right: 20px;
        font-size: 22px;
        font-weight: bold;
        color: #000;
        line-height: 23px;
      }

      .a {
        padding-top: 1px;
        div {
          float: left;
          height: 24px;
          padding: 0 10px;
          margin-right: 15px;
          background-color: #f0f2f5;
          border-radius: 4px;
          color: #f87243;
          line-height: 24px;
          font-size: 14px;
        }
      }
    }

    .enterprise-list {
      border-bottom: 1px solid #f0f2f5;
      padding-bottom: 10px;
      .el-col.el-col-8 {
        margin-bottom: 30px;
        color: #636871;
        font-size: 14px;
        line-height: 15px;
        span {
          color: #000000;
        }
      }
      .el-col.el-col-24 {
        margin-bottom: 30px;

        h5 {
          color: #636871;
          font-size: 14px;
          line-height: 15px;
        }
        div {
          margin-top: 10px;
          padding: 14px 16px;
          color: #000;
          background-color: #f2f7ff;
          border-radius: 8px;
          font-size: 14px;
        }
      }
    }

    .contact {
      padding: 40px 0;
      border-bottom: 1px solid #f0f2f5;

      h3 {
        font-size: 18px;
        margin-bottom: 40px;
        font-weight: 400;
        line-height: 18px;
      }
      .el-table__header-wrapper {
        thead {
          color: #000;
          background-color: red;
          height: 45px;
        }
      }
      .el-table__body-wrapper {
        tr {
          height: 45px;
        }
      }
      .el-table__row.el-table__row--striped {
        td {
          background-color: #f2f7ff;
        }
      }
    }

    .invoice {
      padding: 40px 0 23px;
      border-bottom: 1px solid #f0f2f5;
      font-weight: 400;
      h3 {
        font-size: 18px;
        margin-bottom: 40px;
        line-height: 18px;
      }
      .invoice-top {
        .el-col.el-col-8,
        .el-col.el-col-24 {
          margin-bottom: 30px;
          color: #636871;
          font-size: 14px;
          line-height: 14px;
          span {
            color: #000;
          }
        }
      }
      .invoice-bottom {
        font-size: 14px;
        font-weight: 400;
        .el-col.el-col-24 {
          margin-bottom: 30px;
          h5 {
            color: #636871;
            
            font-size: 14px;
            line-height: 15px;
          }
          .divWord {
            margin-top: 10px;
            padding: 14px 16px;
            color: #000;
            background-color: #f2f7ff;
            border-radius: 8px;
          }
          &:last-child{
            margin-bottom: 20px;
          }
        }
      }
    }

    .return {
      text-align: center;
      margin-top: 20px;
      button {
        width: 95px;
        height: 45px;
      }
    }
  }

  /* 清除浮动 */
  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: ".";
    clear: both;
    height: 0;
  }
  * html .clearfix {
    zoom: 1;
  }
  *:first-child + html .clearfix {
    zoom: 1;
  }
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
}
</style>